import { SET_SEARCH_TRANSACTION_RESPONSE } from "../action";
import { getSearchTransactions } from "../api/api.js";

export const fetchSearchTransactions = (searchFilter) => async (dispatch) => {
  try {
    dispatch({ type: SET_SEARCH_TRANSACTION_RESPONSE, payload: null });
    const response = await getSearchTransactions(searchFilter);
    dispatch({ type: SET_SEARCH_TRANSACTION_RESPONSE, payload: response.data });
    return response;
  } catch (error) {
    console.error("fetchSearchTransactions error ", error);
  }
};
